/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JobDoneRequest
 */
export interface JobDoneRequest {
    /**
     * 
     * @type {number}
     * @memberof JobDoneRequest
     */
    amount: number;
}

/**
 * Check if a given object implements the JobDoneRequest interface.
 */
export function instanceOfJobDoneRequest(value: object): value is JobDoneRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function JobDoneRequestFromJSON(json: any): JobDoneRequest {
    return JobDoneRequestFromJSONTyped(json, false);
}

export function JobDoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobDoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

  export function JobDoneRequestToJSON(json: any): JobDoneRequest {
      return JobDoneRequestToJSONTyped(json, false);
  }

  export function JobDoneRequestToJSONTyped(value?: JobDoneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
    };
}

